import React from 'react';
import MessageTypeDropdown from './MessageTypes';
import TailNumberDropdown from './TailNumberDropdown';
import ToggleSwitch from './ToggleSwitch';
import OverviewDateRange from './OverviewDateRange';

interface OverviewSearchFormProps {
  airline: string;
  setAirline: (v: string) => void;
  canSelectAS: boolean;
  canSelectQX: boolean;
  isXml: 0 | 1;
  setIsXml: (fn: any) => void;
  acNumber: string;
  handleAcNumberChange: (v: string) => void;
  flightNumber: string;
  handleFlightNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  payload: string;
  handleKeywordSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  messageType: string;
  setMessageType: (v: string) => void;
  fromTo: string;
  handleFromToChange: (v: string) => void;
  handleSearch: () => void;
  isFormValid: boolean;
  isSearchLoading: boolean;
  fromToError: string | null;
  // Date range props
  dateRangeMode: 'relative' | 'specific';
  handleDateRangeModeChange: (mode: 'relative' | 'specific') => void;
  relativeTimeValue: number;
  setRelativeTimeValue: (v: number) => void;
  relativeTimeUnit: 'min' | 'hours' | 'days';
  setRelativeTimeUnit: (v: 'min' | 'hours' | 'days') => void;
  startDate: Date | null;
  setStartDate: (v: Date | null) => void;
  endDate: Date | null;
  setEndDate: (v: Date | null) => void;
  DatePickereStartDateIsOpen: boolean;
  setDatePickereStartDateIsOpen: (v: boolean) => void;
  DatePickereEndDateIsOpen: boolean;
  setDatePickereEndDateIsOpen: (v: boolean) => void;
  calendarViewDate: Date;
  navigateToPreviousMonth: () => void;
  advanceCalendarByMonth: () => void;
  navigateToSpecificMonth: (month: number, year: number) => void;
}

const OverviewSearchForm: React.FC<OverviewSearchFormProps> = ({
  airline, setAirline, canSelectAS, canSelectQX,
  isXml, setIsXml,
  acNumber, handleAcNumberChange,
  flightNumber, handleFlightNumberChange,
  payload, handleKeywordSearchChange,
  messageType, setMessageType,
  fromTo, handleFromToChange,
  handleSearch, isFormValid, isSearchLoading, fromToError,
  dateRangeMode, handleDateRangeModeChange,
  relativeTimeValue, setRelativeTimeValue,
  relativeTimeUnit, setRelativeTimeUnit,
  startDate, setStartDate, endDate, setEndDate,
  DatePickereStartDateIsOpen, setDatePickereStartDateIsOpen,
  DatePickereEndDateIsOpen, setDatePickereEndDateIsOpen,
  calendarViewDate,
  navigateToPreviousMonth, advanceCalendarByMonth, navigateToSpecificMonth,
}) => (
  <div className="left-section">
    <div className="search-container">
      <div className="search-section">
        <div className="search-input hide-button">
          <label>Select Airline</label>
          <div className="airline-radio-container">
            {canSelectAS && (
              <>
                <input type="radio" id="as" name="airline" value="AS"
                  checked={airline === 'AS'} onChange={(e) => setAirline(e.target.value)} />
                <label htmlFor="as">Alaska</label>
              </>
            )}
            {canSelectQX && (
              <>
                <input type="radio" id="horizon" name="airline" value="QX"
                  checked={airline === 'QX'} onChange={(e) => setAirline(e.target.value)} />
                <label htmlFor="horizon">Horizon</label>
              </>
            )}
          </div>
        </div>
        <div className="search-input hide-button">
          <div className="search-input">
            <ToggleSwitch
              label="Include XML Messages"
              checked={isXml === 1}
              onChange={() => setIsXml((prev: any) => (prev === 0 ? 1 : 0))}
            />
          </div>
        </div>
        <div className="search-input">
          <label>Search by AC Reg #</label>
          {airline === 'AS' ? (
            <TailNumberDropdown value={acNumber} onChange={handleAcNumberChange}
              airline={airline} canSelectAS={canSelectAS} canSelectQX={canSelectQX} flag='1' />
          ) : (
            <TailNumberDropdown value={acNumber} onChange={handleAcNumberChange}
              airline={airline} canSelectAS={canSelectAS} canSelectQX={canSelectQX} flag='2' />
          )}
        </div>
        <div className="search-input">
          <label>Search by Flight Number</label>
          <input type="text" value={flightNumber} onChange={handleFlightNumberChange} />
        </div>
        <div className="search-input">
          <label>Search by Keyword</label>
          <input type="text" value={payload} onChange={handleKeywordSearchChange} />
        </div>
        <div className="search-input">
          <label>Search by Message Type</label>
          <MessageTypeDropdown value={messageType} onChange={setMessageType} isXml={isXml} />
        </div>
        <div className="search-input">
          <label>From/To</label>
          <input type="text" value={fromTo}
            onChange={(e) => handleFromToChange(e.target.value)}
            placeholder="ex. SEA/AUS" />
        </div>

        <OverviewDateRange
          dateRangeMode={dateRangeMode}
          handleDateRangeModeChange={handleDateRangeModeChange}
          relativeTimeValue={relativeTimeValue}
          setRelativeTimeValue={setRelativeTimeValue}
          relativeTimeUnit={relativeTimeUnit}
          setRelativeTimeUnit={setRelativeTimeUnit}
          startDate={startDate} setStartDate={setStartDate}
          endDate={endDate} setEndDate={setEndDate}
          DatePickereStartDateIsOpen={DatePickereStartDateIsOpen}
          setDatePickereStartDateIsOpen={setDatePickereStartDateIsOpen}
          DatePickereEndDateIsOpen={DatePickereEndDateIsOpen}
          setDatePickereEndDateIsOpen={setDatePickereEndDateIsOpen}
          calendarViewDate={calendarViewDate}
          navigateToPreviousMonth={navigateToPreviousMonth}
          advanceCalendarByMonth={advanceCalendarByMonth}
          navigateToSpecificMonth={navigateToSpecificMonth}
        />

        <button
          className="search-button"
          onClick={handleSearch}
          disabled={!isFormValid || isSearchLoading}
          data-error={
            !isFormValid && fromToError ? "fromto" : !isFormValid ? "general" : ""
          }
        >
          {isSearchLoading ? 'Searching...' : 'Search'}
        </button>
      </div>
    </div>
  </div>
);

export default OverviewSearchForm;
